export var Currency;
(function (Currency) {
    Currency["INR"] = "INR";
    Currency["USD"] = "USD";
})(Currency || (Currency = {}));
export const COUNTRY_CODE_TO_CURRENCY = {
    "+91": Currency.INR,
    "+1": Currency.USD,
    "+44": Currency.USD,
    "+61": Currency.USD,
    "+81": Currency.USD,
    "+86": Currency.USD,
    "+33": Currency.USD,
    "+49": Currency.USD,
    "+39": Currency.USD,
    "+34": Currency.USD,
    "+31": Currency.USD,
    "+46": Currency.USD,
    "+47": Currency.USD,
    "+41": Currency.USD,
    "+43": Currency.USD,
    "+32": Currency.USD,
    "+45": Currency.USD,
    "+358": Currency.USD,
    "+30": Currency.USD,
    "+60": Currency.USD,
    "+65": Currency.USD,
    "+62": Currency.USD,
    "+66": Currency.USD,
    "+84": Currency.USD,
    "+63": Currency.USD,
    "+64": Currency.USD,
    "+27": Currency.USD,
    "+234": Currency.USD,
    "+20": Currency.USD,
};
export const getCurrencyByCountryCode = (countryCode) => {
    return COUNTRY_CODE_TO_CURRENCY[countryCode] || Currency.USD;
};
const isUsableAmount = (value) => typeof value === "number" && Number.isFinite(value) && value >= 0;
const applyDiscount = (amount, discount, discountType) => {
    const normalized = discountType === "FIXED" ? "FIXED" : "PERCENTAGE";
    const discountedPrice = normalized === "FIXED" ? amount - discount : amount - (amount * discount) / 100;
    return { discountedPrice: Math.max(0, discountedPrice), discountType: normalized };
};
export const getPackagePricingByCurrency = (pack, currency, audience) => {
    if (audience === "INTERNATIONAL") {
        const rows = pack.internationalPackagesPricing ??
            pack.internationPatientPackagePricingList ??
            [];
        const row = rows.find((entry) => entry.currency === currency);
        if (!row || !isUsableAmount(row.amount))
            return null;
        const { discountedPrice, discountType } = applyDiscount(row.amount, isUsableAmount(row.discount) ? row.discount : 0, row.discountType);
        return {
            price: row.amount,
            discountedPrice,
            discount: isUsableAmount(row.discount) ? row.discount : 0,
            discountType,
            currency: row.currency,
        };
    }
    if (!isUsableAmount(pack.packagePrice))
        return null;
    const discount = isUsableAmount(pack.discount) ? pack.discount : 0;
    if (!isUsableAmount(pack.discountedPrice) && discount !== 0)
        return null;
    return {
        price: pack.packagePrice,
        discountedPrice: isUsableAmount(pack.discountedPrice)
            ? pack.discountedPrice
            : pack.packagePrice,
        discount,
        discountType: pack.discountType === "FIXED" ? "FIXED" : "PERCENTAGE",
        currency,
    };
};
export const getCurrencySymbol = (currency) => {
    const symbols = {
        INR: "₹",
        USD: "$",
        GBP: "£",
        EUR: "€",
        AUD: "A$",
        JPY: "¥",
        CNY: "¥",
        SEK: "kr",
        NOK: "kr",
        CHF: "CHF",
        DKK: "kr",
        MYR: "RM",
        SGD: "S$",
        IDR: "Rp",
        THB: "฿",
        VND: "₫",
        PHP: "₱",
        NZD: "NZ$",
        ZAR: "R",
        NGN: "₦",
        EGP: "E£",
    };
    return symbols[currency] || currency;
};
